import { I18n } from '@calendly/i18n'

import { formatDuration } from 'services/event_types'

export const getSelectOptions = () => [
  { id: 15, name: formatDuration(15, undefined, true) },
  { id: 30, name: formatDuration(30, undefined, true) },
  { id: 45, name: formatDuration(45, undefined, true) },
  { id: 60, name: formatDuration(60, undefined, true) },
  { id: 'custom', name: I18n.t('publisher.event_types.availability.duration_fieldset.custom') },
]
